import { JENIS_DESA, JENIS_DUSUN } from './Koneksi';

const jwt = require('jsonwebtoken');

export function DataToken(token) {
	const decoded = jwt.decode(token, { complete: true });
	if (decoded != null) {
		return decoded.payload;
	} else {
		return null
	}
	
}

export function generateAlamat(tmpDetailPenduduk) {
	// New set alamat
	let alamat = '';
	const dataKK = tmpDetailPenduduk.data_kk
	const dataDesa = tmpDetailPenduduk.data_keldes

	if (dataKK !== null && dataDesa !== null) {
		const dataKecamatan = dataDesa.data_kecamatan
		const dataKabkota = dataKecamatan.data_kabkota
		const dataProvinsi = dataKabkota.data_provinsi

		if (JENIS_DESA.toLowerCase() !== 'kelurahan') {
			if (dataKK.data_rt) {
				const dataRT = dataKK.data_rt
				const dataRW = dataRT.data_rw ? dataRT.data_rw : {nama: '-'}
				const dataDusun = dataRW.data_dusun ? dataRW.data_dusun : {nama: '-'}

				// Jika tidak ada RT
				if (dataRT.id === '0') {
					alamat = `${JENIS_DUSUN} ${dataDusun.nama}, ${JENIS_DESA} ${dataDesa.nama}, Kec. ${dataKecamatan.nama}, ${dataKabkota.nama}, ${dataProvinsi.nama}`
				} else {
					alamat = `RT. ${dataRT.nama}/RW. ${dataRW.nama}, ${JENIS_DUSUN} ${dataDusun.nama}, ${JENIS_DESA} ${dataDesa.nama}, Kec. ${dataKecamatan.nama}, ${dataKabkota.nama}, ${dataProvinsi.nama}`
				}
			}
		} else { // Jika kelurahan tanpa dusun
			if (dataKK.data_rt) {
				const dataRT = dataKK.data_rt
				const dataRW = dataRT.data_rw ? dataRT.data_rw : {nama: '-'}

				alamat = `RT. ${dataRT.nama}/RW. ${dataRW.nama}, ${JENIS_DESA} ${dataDesa.nama}, Kec. ${dataKecamatan.nama}, ${dataKabkota.nama}, ${dataProvinsi.nama}`
			}
		}
	}

	return alamat
}

export function numberSeparator(x) {
	if (x === null || x === undefined) return "0";
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function TanggalToISO(tgl) {
	let ta = tgl.split('/');
	return new Date(ta[2] + '-' + ta[1] + '-' + ta[0]).toISOString();
}

export function Tanggal(tgl) {
	var d = new Date(tgl);
	// var month = new Array();
	var month = [];
	month[0] = 'Januari';
	month[1] = 'Februari';
	month[2] = 'Maret';
	month[3] = 'April';
	month[4] = 'Mei';
	month[5] = 'Juni';
	month[6] = 'Juli';
	month[7] = 'Agustus';
	month[8] = 'September';
	month[9] = 'Oktober';
	month[10] = 'November';
	month[11] = 'Desember';
	var tanggal = d.getDate();
	var bln = month[d.getMonth()];
	var tahun = d.getFullYear();

	return tanggal + ' ' + bln + ' ' + tahun;
}

export function Bulan(bln) {
	// var month = new Array();
	var bulanFilter = [];
	switch (bln) {
		case '01':
			bulanFilter = 'Januari';
			break;

		case '02':
			bulanFilter = 'Februari';
			break;

		case '03':
			bulanFilter = 'Maret';
			break;

		case '04':
			bulanFilter = 'April';
			break;

		case '05':
			bulanFilter = 'Mei';
			break;

		case '06':
			bulanFilter = 'Juni';
			break;

		case '07':
			bulanFilter = 'Juli';
			break;

		case '08':
			bulanFilter = 'Agustus';
			break;

		case '09':
			bulanFilter = 'September';
			break;

		case '10':
			bulanFilter = 'Oktober';
			break;

		case '11':
			bulanFilter = 'November';
			break;

		case '12':
			bulanFilter = 'Desember';
			break;
		default:
			// no default
			break;
	}

	return bulanFilter;
}

export function Hari(tgl) {
	var d = new Date(tgl);
	// var days = new Array();
	var days = [];
	days[0] = 'Minggu';
	days[1] = 'Senin';
	days[2] = 'Selasa';
	days[3] = 'Rabu';
	days[4] = 'Kamis';
	days[5] = "Jum'at";
	days[6] = 'Sabtu';
	// var tanggal = Tanggal(d);
	var hari = days[d.getDay()];
	return hari;
}

export function HariTanggal(tgl) {
	var d = new Date(tgl);
	// var days = new Array();
	var days = [];
	days[0] = 'Minggu';
	days[1] = 'Senin';
	days[2] = 'Selasa';
	days[3] = 'Rabu';
	days[4] = 'Kamis';
	days[5] = "Jum'at";
	days[6] = 'Sabtu';
	var tanggal = Tanggal(d);
	var hari = days[d.getDay()];
	return hari + ', ' + tanggal;
}

export function HariTanggalJam(tgl) {
	var d = new Date(tgl);
	// var days = new Array();
	var days = [];
	days[0] = 'Minggu';
	days[1] = 'Senin';
	days[2] = 'Selasa';
	days[3] = 'Rabu';
	days[4] = 'Kamis';
	days[5] = "Jum'at";
	days[6] = 'Sabtu';
	var tanggal = Tanggal(d);
	var hari = days[d.getDay()];
	var menit = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
	var jam = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
	var waktu = jam + ':' + menit;
	return hari + ', ' + tanggal + ' ' + waktu;
}
export function formatYMD(inputDate) {
    var date = new Date(inputDate);
    if (!isNaN(date.getTime())) {
        // Months use 0 index.
        return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
    }
}
export function formatDMY(inputDate) {
    var date = new Date(inputDate);
    if (!isNaN(date.getTime())) {
        // Months use 0 index.
		let showData = date.getDate() +  '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
        return showData;
    }
}
export function formatHIS(tgl) {
	var d = new Date(tgl);
	var menit = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
	var jam = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
	var waktu = jam + ':' + menit;
	return waktu;
}
export function formatRupiah(nominal) {
	let fix_nominal = parseInt(nominal)

	return new Intl.NumberFormat("id-ID", {
		style: "currency",
		currency: "IDR"
	  }).format(fix_nominal);
}

export function CapitalizeWord(data) {
	var splitStr = data.toLowerCase().split(' ');
   for (var i = 0; i < splitStr.length; i++) {
       // You do not need to check if i is larger than splitStr length, as your for does that for you
       // Assign it back to the array
       splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
   }
   // Directly return the joined string
   return splitStr.join(' '); 
}